import { render, staticRenderFns } from "./NormalSearchNav486.vue?vue&type=template&id=06533652&scoped=true&"
import script from "./NormalSearchNav486.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav486.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06533652",
  null
  
)

export default component.exports